<template>
  <section class="career-screen-container">
    <div class="career-screen-content">
      <main-text-block :main-paragraph="mainParagraph"
                       :is-active-mini-paragraph="$isMobile"
                       v-animateonscroll="{ enterClass: 'fade-in'}"
                       :config-block="configBlock"
                       :main-title="mainTitle"/>
    </div>
    <div :class="['cards-container-wrapper', 'animation-opacity', {
      'is-active-opacity' : isVisible(0)
    }]">
      <div v-if="!$isMobile"
           :class="['cards-container', {'is-active-height' : activeHeight}]"
           v-animateonscroll="{ enterClass: 'fade-in'}"
           @animationend="showAnimation">
        <card-icon-title-info v-for="(item, index) in cardsInfo"
                              :is-active-gradient="isActiveGradient"
                              @setActiveHeight="setActiveHeight"
                              :key="index"
                              :item="item"/>
      </div>
      <slider-banner v-else
                     v-animateonscroll="{ enterClass: 'fade-in'}"
                     @animationend="showAnimation"
                     :cards-info="cardsInfo"
                     :class="['cards-container', {'is-active-height' : activeHeight}]"
                     :is-active-row="true"
                     :is-active-padding="false"
                     :class-name="'card-service-wrapper'"
                     @changeId="changeId">
        <template v-slot:card="{ item }">
          <card-icon-title-info :is-active-gradient="isActiveGradient"
                                @setActiveHeight="setActiveHeight"
                                :item="item"/>
        </template>
      </slider-banner>
    </div>
    <div class="bg-container" :class="['animation-opacity', {'is-active-opacity' : isVisible(0)}]">
      <img :src="getUrl('team.webp')" alt="decoration">
    </div>
  </section>
</template>

<script>
import MainTextBlock from "@/components/entities/blocks/MainTextBlock.vue";
import CardIconTitleInfo from "@/components/entities/cards/CardIconTitleInfo.vue";
import {mapActions} from "vuex";
import SliderBanner from "@/components/entities/SliderBanner.vue";

export default {
  name: "CareerScreen",
  components: {SliderBanner, CardIconTitleInfo, MainTextBlock},
  data() {
    return {
      idSubCard: 0,
      isActiveGradient: true,
      activeHeight: false,
      visibleIndexItem: -1,
      lengthAnimation: 4,
      mainTitle: 'Карьера',
      mainParagraph: 'Хорошая работа — это когда комфортно и интересно.\n' +
          'Прозрачные процессы, сильная команда и реальные перспективы роста.\n' +
          'Ознакомьтесь с актуальными вакансиями и присоединяйтесь.',
      cardsInfo: [
        {
          id: 0,
          idCard: 'block-1',
          height: 0,
          icon: 'career/1',
          title: 'Мы всегда рады студентам',
          mainText: 'Мы открыты для молодых специалистов и стремимся создавать для них комфортную среду для развития.',
          text: '\n— Предлагаем наставничество: помощь опытных коллег на каждом этапе\n' +
              '\n— Возможен индивидуальный график, адаптированный под расписание учебы'
        },
        {
          id: 1,
          idCard: 'block-2',
          height: 0,
          icon: 'career/2',
          title: 'Наши ценности',
          mainText: 'Мы придерживаемся принципов, которые формируют культуру доверия\nи ответственности:',
          text: ' — Безопасность труда — соблюдаем стандарты и заботимся о здоровье команды\n' +
              '\n — Командная работа — верим в силу сотрудничества и взаимопомощи\n' +
              '\n — Клиентоориентированность — понимаем задачи клиентов и стремимся их превзойти\n' +
              '\n — Инновации — поддерживаем инициативы и тестируем новые подходы\n' +
              '\n — Вовлеченность — ценим вклад каждого\nи стремимся к общим результатам'
        },
        {
          id: 2,
          idCard: 'block-3',
          height: 0,
          icon: 'career/1',
          title: 'Корпоративные мероприятия',
          mainText: 'Мы регулярно проводим внутренние события, которые помогают команде оставаться сплочённой:',
          text: ' — Строим крепкие связи внутри коллектива\n' +
              '\n — Повышаем уровень доверия и вовлеченности\n' +
              '\n — Помогаем сохранить баланс между работой и личной жизнью'
        },
        {
          id: 3,
          idCard: 'block-4',
          height: 0,
          icon: 'career/2',
          title: 'Атмосфера',
          mainText: 'Мы придерживаемся демократичного стиля управления. Внутри команды царит уважение, открытость и поддержка.',
          text: 'Рабочая обстановка остаётся неформальной, но ориентированной на результат — у нас принято обсуждать идеи, делиться обратной связью и вместе искать решения.'
        }
      ]
    }
  },
  computed: {
    configBlock() {
      return {
        textAlign: !this.$isMobile ? 'center' : 'left',
        // activeRequest: true,
        btnInfo: {
          btnText: 'Смотреть вакансии на hh.ru',
          action: () => this.routTo()
        }
      }
    },
  },
  mounted() {
    if(this.$isMobile) {
      this.setActiveHeight();
    }
  },
  methods: {
    routTo() {
      window.open('https://hh.ru/employer/2292026', '_blank')
    },
    changeId(value) {
      this.idSubCard = value;
      this.setActiveHeight();
    },
    setActiveHeight() {
      let height = 0;
      if(!this.$isMobile) {
        this.isActiveGradient = false;
        let blocks = document.querySelectorAll('.card-icon-title-container');
        if(blocks) {
          blocks.forEach(i => {
            if(i.scrollHeight > height) {
              height = i.scrollHeight;
            }
          })
        }
      } else {
        let item = this.cardsInfo.find(item => item.id === this.idSubCard);
        if(item) {
          let block = document.querySelector(`.card-icon-title-container-${item.id}`)
          if(block) {
            height = block.scrollHeight;
          }
        }
      }
      this.activeHeight = `${ height }px`;
    },
  }
}
</script>

<style scoped lang="scss">
.career-screen-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--color-dark-gradient);
  position: relative;

  .bg-container {
    top: 0;
    width: 100%;

    & img {
      position: relative;
      z-index: 0;
    }
    //
    &:after {
      pointer-events: none;
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      background: rgba(var(--color-dark-purple-rgba), .8);
    }
  }
  .career-screen-content {
    display: flex;
    position: relative;
    z-index: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    max-width: var(--main-max-width);
    margin: 0 auto
  }

  .cards-container-wrapper {
    position: relative;
    z-index: 2;
    backdrop-filter: blur(40px);
    &:after {
      transition: all .3s ease;
      pointer-events: none;
      background: var(--color-dark-opacity-gradient);
      z-index: 1;
      position: absolute;
      content: "";
      height: 100%;
      width: 100%;
      bottom: 0;
      right: 0;
      opacity: 0;

      @media(max-width: 769px) {
        width: 50%;
        height: 25%;
        background: linear-gradient(135deg, rgba(var(--color-dark-purple-rgba), 0) 25%, var(--color-dark-purple));
      }
    }

    &.is-active-gradient {
      &:after {
        opacity: 1;
      }
    }
    .cards-slider-container {
      position: relative;
      z-index: 1;
    }
    .cards-container {
      position: relative;
      z-index: 1;
      margin: 0 auto;
      max-width: var(--main-max-width);
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      transition: all .6s ease;
    }
  }

}

@media (max-width: 3024px){
  .career-screen-container {
    row-gap: 60px;
    padding-top: 160px;
    padding-bottom: 120px;
    .career-screen-content {
      .main-block-container {
        max-width: 1180px;
      }
    }
    .cards-container-wrapper {
      padding: 60px;
    }

    .card-icon-title-container {
      max-width: 400px;
      width: 100%;
    }
  }
}


@media (max-width: 1920px) {
  .career-screen-container {
    row-gap: 80px;
    padding-top: 120px;
    padding-bottom: 60px;
    .career-screen-content {
      .main-block-container {
        max-width: 819px;
      }
    }
    .cards-container-wrapper {
      padding: 60px;
    }

    .card-icon-title-container {
      max-width: 355px;
      width: 100%;
    }
  }
}
@media (max-width: 1600px) {
  .career-screen-container {
    row-gap: 80px;
    padding-top: 80px;
    padding-bottom: 40px;
    .career-screen-content {
      .main-block-container {
        max-width: 819px;
      }
    }
    .cards-container-wrapper {
      padding: 40px;
    }

    .card-icon-title-container {
      max-width: 265px;
      width: 100%;
    }
  }
}
@media (max-height: 800px) {
  .career-screen-container {
    row-gap: 60px;
    padding-top: 60px;
    padding-bottom: 20px;
    .career-screen-content {
      .main-block-container {
        max-width: 550px;
      }
    }
    .cards-container-wrapper {
      padding: 30px;
    }

    .card-icon-title-container {
      max-width: 235px;
      width: 100%;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .career-screen-container {
    row-gap: 80px;
    padding-top: 80px;
    padding-bottom: 40px;
    .career-screen-content {
      .main-block-container {
        max-width: 819px;
      }
    }
    .cards-container-wrapper {
      padding: 40px;
    }

    .card-icon-title-container {
      max-width: 265px;
      width: 100%;
    }
  }
}

@media (max-width: 1133px) {
  .career-screen-container {
    row-gap: 60px;
    padding-top: 60px;
    padding-bottom: 20px;
    .career-screen-content {
      .main-block-container {
        max-width: 550px;
      }
    }
    .cards-container-wrapper {
      padding: 30px;
    }

    .card-icon-title-container {
      max-width: 235px;
      width: 100%;
    }
  }
}
@media (max-width: 769px) {
  .career-screen-container {
    row-gap: 24px;
    padding-top: 48px;
    padding-bottom: 48px;
    .career-screen-content {
      .main-block-container {
        padding: 0 16px;
        max-width: 100%;
      }
    }
    .cards-slider-container {
      ::v-deep(.card-service-wrapper) {
          min-height: 100%;
          max-height: 100%;
      }
    }
    .cards-container-wrapper {
      padding: 30px 0;
    }

    .card-icon-title-container {
      max-width: 235px;
      width: 100%;
    }
  }
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  .career-screen-container {
    .career-screen-content {
      .main-block-container {
        padding: 0 20px;
      }
    }
  }
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .career-screen-container {
    row-gap: 240px;
    padding-top: 160px;
    padding-bottom: 280px;
    .career-screen-content {
      .main-block-container {
        max-width: 1646px;
      }
    }
    .cards-container-wrapper {
      padding: 60px;
    }

    .card-icon-title-container {
      max-width: 725px;
      width: 100%;
    }
  }
}

</style>